import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = '/api';

export const benefitCategoryApi = createApi({
  reducerPath: 'benefitCategoryApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    AddBenefitCategory: builder.mutation({
      query: ({ ledger, Token }) => ({
        url: `/admin/benefit-category`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: { ledger: ledger }
      }),
      invalidatesTags: ['benefits', 'benefitCat'],
    }),
    getBenefitCategory: builder.query({
      query: (Token) => ({
        url: `/admin/benefit-category`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Token}`,
        }
      }),
      providesTags: ['benefitCat'],
      invalidatesTags: ['benefits'],
    }),
    delBenefitCategory: builder.mutation({
      query: ({ Token, Id }) => ({
        url: `/admin/benefit-category/${Id}`,
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${Token}`,
        }
      }),
      invalidatesTags: ['benefits', 'benefitCat'],
    })
  }),
});

export const {
  useAddBenefitCategoryMutation,
  useGetBenefitCategoryQuery,
  useDelBenefitCategoryMutation
} = benefitCategoryApi;
